import React from "react";

// External Components
import Dropdown from "react-bootstrap/Dropdown";

// Icons
import ArrowDown from "../../../assets/icons/arrows/chevron-down.svg";

// Stylesheets
import "./RequestDropdown.scss";

//Constants
export const CLEAR_SELECTION_TEXT = "Clear Selection";

function RequestDropdown({
  value = "",
  placeholder = "Select",
  options = [],
  onChange = () =>
    console.log("On change handler is provided in RequestDropdown"),
  optionsMaxHeight = 300,
  disabled = false,
}) {
  const dropdownBtn = React.forwardRef(({ onClick, disabled }, ref) => (
    <div
      className="request-dropdown"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        if (!disabled) {
          onClick(e);
        }
      }}
    >
      <div
        className="dropdown-container"
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <div>{value === "" ? placeholder : value}</div>
        <img className="dropdown-icon" src={ArrowDown} alt="down" />
      </div>
    </div>
  ));

  return (
    <Dropdown>
      <Dropdown.Toggle as={dropdownBtn} id="dropdown-basic" disabled={disabled}>
        Dropdown Button
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="request-dropdown-option"
        style={{ maxHeight: `${optionsMaxHeight}px`, overflowY: "auto" }}
      >
        {options.map((option, index) => (
          <React.Fragment key={index}>
            <Dropdown.Item
              as="a"
              className={`request-dropdown-items ${
                option === value ? "selected" : ""
              }`}
              onClick={() => onChange(option)}
            >
              <div className="color-code-item py-2">{option}</div>
            </Dropdown.Item>
            {options.length - 1 !== index && <Dropdown.Divider />}
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default RequestDropdown;
